<template>
  <div class="c-memberItem">
    <a class="c-memberItem__ineer" href="" @click.prevent="itemClick($event)">
        <div class="c-memberItem__imgArea">
            <picture class="c-memberItem__img">
                <source :srcset="memberDada.list_img.pc" media="(min-width: 1025px)"/>
                <source :srcset="memberDada.list_img.tab" media="(min-width: 768px)"/>
                <img :src="memberDada.list_img.sp" :alt="memberDada.name">
            </picture>
            <picture class="c-memberItem__hoverImg">
                <source :srcset="memberDada.list_hover_img.pc" media="(min-width: 1025px)"/>
                <source :srcset="memberDada.list_hover_img.tab" media="(min-width: 768px)"/>
                <img :src="memberDada.list_hover_img.sp" :alt="memberDada.name">
            </picture>
        </div>
        <div class="c-memberItem__textArea">
            <h4 class="c-memberItem__name">{{ memberDada.name }}</h4>
            <p class="c-memberItem__text">{{ departmentText }}チーム</p>
        </div>
    </a>
  </div>
</template>

<script>
    export default {
       props:{
            index: Number,
            id: Number,
            departmentText: String,
            memberDada: {},
        },
        data() {
            return {
            };
        },
        created() {
            this.message = 'hello';
        },
        methods: {
            itemClick(e) {
                this.$emit('itemClick', this.item_dada)
            }
        }
    }
</script>
<style scoped>

</style>